var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlertStatus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 140,
    viewBox: "0 0 483 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2828_22625",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 483,
    height: 140
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23857 2.23858 0 5 0H478C480.761 0 483 2.23858 483 5V135C483 137.761 480.761 140 478 140H4.99999C2.23857 140 0 137.761 0 135V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2828_22625)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450.452,
    cy: 105.842,
    r: 83.8873,
    transform: "rotate(-67.4327 450.452 105.842)",
    fill: "#E2BEE8",
    stroke: "white",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_2828_22625",
    maskUnits: "userSpaceOnUse",
    x: 338.834,
    y: -5.98664,
    width: 147.81,
    height: 192.062,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 338.834,
    y: -5.98664,
    width: 147.81,
    height: 192.062
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.996 174.311C420.25 178.512 415.404 180.539 411.397 178.382C394.734 169.412 381.585 154.925 374.299 137.278C365.961 117.081 365.988 94.3993 374.374 74.222C382.759 54.0446 398.817 38.0248 419.014 29.6867C436.66 22.4015 456.204 21.5019 474.317 26.984C478.672 28.3022 480.654 33.1669 478.908 37.3687C477.162 41.5704 472.347 43.5064 467.961 42.2976C453.92 38.4284 438.906 39.3007 425.301 44.9173C409.144 51.5877 396.298 64.4036 389.589 80.5455C382.881 96.6874 382.86 114.833 389.53 130.991C395.147 144.595 405.12 155.852 417.767 163.074C421.718 165.331 423.743 170.109 421.996 174.311Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.996 174.311C420.25 178.512 415.404 180.539 411.397 178.382C394.734 169.412 381.585 154.925 374.299 137.278C365.961 117.081 365.988 94.3993 374.374 74.222C382.759 54.0446 398.817 38.0248 419.014 29.6867C436.66 22.4015 456.204 21.5019 474.317 26.984C478.672 28.3022 480.654 33.1669 478.908 37.3687C477.162 41.5704 472.347 43.5064 467.961 42.2976C453.92 38.4284 438.906 39.3007 425.301 44.9173C409.144 51.5877 396.298 64.4036 389.589 80.5455C382.881 96.6874 382.86 114.833 389.53 130.991C395.147 144.595 405.12 155.852 417.767 163.074C421.718 165.331 423.743 170.109 421.996 174.311Z",
    fill: "#E2BEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.996 174.311C420.25 178.512 415.404 180.539 411.397 178.382C394.734 169.412 381.585 154.925 374.299 137.278C365.961 117.081 365.988 94.3993 374.374 74.222C382.759 54.0446 398.817 38.0248 419.014 29.6867C436.66 22.4015 456.204 21.5019 474.317 26.984C478.672 28.3022 480.654 33.1669 478.908 37.3687C477.162 41.5704 472.347 43.5064 467.961 42.2976C453.92 38.4284 438.906 39.3007 425.301 44.9173C409.144 51.5877 396.298 64.4036 389.589 80.5455C382.881 96.6874 382.86 114.833 389.53 130.991C395.147 144.595 405.12 155.852 417.767 163.074C421.718 165.331 423.743 170.109 421.996 174.311Z",
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-3-outside-1_2828_22625)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-2_2828_22625",
    maskUnits: "userSpaceOnUse",
    x: 338.834,
    y: 29.0998,
    width: 133.226,
    height: 156.972,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 338.834,
    y: 29.0998,
    width: 133.226,
    height: 156.972
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.996 174.307C420.25 178.508 415.404 180.535 411.397 178.378C400.583 172.556 391.175 164.371 383.895 154.393C374.992 142.19 369.615 127.773 368.353 112.72C367.091 97.6669 369.992 82.5565 376.738 69.0407C382.254 57.9896 390.168 48.3525 399.862 40.8107C403.453 38.0167 408.569 39.2077 410.991 43.0599C413.412 46.9122 412.212 51.9607 408.692 54.8437C401.523 60.7151 395.647 68.0533 391.481 76.3997C386.084 87.2123 383.763 99.3007 384.773 111.343C385.783 123.386 390.084 134.919 397.207 144.682C402.705 152.218 409.72 158.475 417.767 163.07C421.719 165.327 423.743 170.105 421.996 174.307Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.996 174.307C420.25 178.508 415.404 180.535 411.397 178.378C400.583 172.556 391.175 164.371 383.895 154.393C374.992 142.19 369.615 127.773 368.353 112.72C367.091 97.6669 369.992 82.5565 376.738 69.0407C382.254 57.9896 390.168 48.3525 399.862 40.8107C403.453 38.0167 408.569 39.2077 410.991 43.0599C413.412 46.9122 412.212 51.9607 408.692 54.8437C401.523 60.7151 395.647 68.0533 391.481 76.3997C386.084 87.2123 383.763 99.3007 384.773 111.343C385.783 123.386 390.084 134.919 397.207 144.682C402.705 152.218 409.72 158.475 417.767 163.07C421.719 165.327 423.743 170.105 421.996 174.307Z",
    fill: "#9C44C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.996 174.307C420.25 178.508 415.404 180.535 411.397 178.378C400.583 172.556 391.175 164.371 383.895 154.393C374.992 142.19 369.615 127.773 368.353 112.72C367.091 97.6669 369.992 82.5565 376.738 69.0407C382.254 57.9896 390.168 48.3525 399.862 40.8107C403.453 38.0167 408.569 39.2077 410.991 43.0599C413.412 46.9122 412.212 51.9607 408.692 54.8437C401.523 60.7151 395.647 68.0533 391.481 76.3997C386.084 87.2123 383.763 99.3007 384.773 111.343C385.783 123.386 390.084 134.919 397.207 144.682C402.705 152.218 409.72 158.475 417.767 163.07C421.719 165.327 423.743 170.105 421.996 174.307Z",
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-4-outside-2_2828_22625)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-5-outside-3_2828_22625",
    maskUnits: "userSpaceOnUse",
    x: 339.758,
    y: 76.5696,
    width: 112.731,
    height: 109.493,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 339.758,
    y: 76.5696,
    width: 112.731,
    height: 109.493
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.996 174.298C420.25 178.5 415.403 180.526 411.397 178.369C395.891 170.021 383.397 156.881 375.859 140.806C368.321 124.731 366.208 106.722 369.706 89.463C370.61 85.0035 375.268 82.5731 379.615 83.9175C383.962 85.262 386.341 89.874 385.548 94.3546C383.196 107.665 384.983 121.452 390.778 133.81C396.573 146.168 406.029 156.359 417.767 163.062C421.718 165.318 423.743 170.096 421.996 174.298Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.996 174.298C420.25 178.5 415.403 180.526 411.397 178.369C395.891 170.021 383.397 156.881 375.859 140.806C368.321 124.731 366.208 106.722 369.706 89.463C370.61 85.0035 375.268 82.5731 379.615 83.9175C383.962 85.262 386.341 89.874 385.548 94.3546C383.196 107.665 384.983 121.452 390.778 133.81C396.573 146.168 406.029 156.359 417.767 163.062C421.718 165.318 423.743 170.096 421.996 174.298Z",
    fill: "#9C44C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.996 174.298C420.25 178.5 415.403 180.526 411.397 178.369C395.891 170.021 383.397 156.881 375.859 140.806C368.321 124.731 366.208 106.722 369.706 89.463C370.61 85.0035 375.268 82.5731 379.615 83.9175C383.962 85.262 386.341 89.874 385.548 94.3546C383.196 107.665 384.983 121.452 390.778 133.81C396.573 146.168 406.029 156.359 417.767 163.062C421.718 165.318 423.743 170.096 421.996 174.298Z",
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-5-outside-3_2828_22625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.763 100.001C462.763 105.305 460.631 110.392 456.835 114.143C453.04 117.894 447.893 120.001 442.525 120.001C437.158 120.001 432.01 117.894 428.215 114.143C424.419 110.392 422.287 105.305 422.287 100.001C422.287 94.6966 424.419 89.6096 428.215 85.8588C432.01 82.1081 437.158 80.001 442.525 80.001C447.893 80.001 453.04 82.1081 456.835 85.8588C460.631 89.6096 462.763 94.6966 462.763 100.001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.914 96.5674L439.771 106.568C439.383 106.889 438.887 107.055 438.381 107.032C437.876 107.01 437.397 106.801 437.04 106.447L432.992 102.447C432.615 102.069 432.404 101.56 432.406 101.03C432.408 100.499 432.622 99.9913 433.001 99.6164C433.381 99.2414 433.895 99.03 434.431 99.0282C434.968 99.0264 435.483 99.2345 435.865 99.607L438.597 102.327L449.324 93.4871C449.528 93.3134 449.764 93.1815 450.021 93.0992C450.277 93.0169 450.547 92.9858 450.815 93.0078C451.083 93.0298 451.344 93.1045 451.583 93.2274C451.822 93.3502 452.034 93.5189 452.206 93.7235C452.378 93.9281 452.507 94.1646 452.585 94.419C452.664 94.6735 452.69 94.9409 452.663 95.2056C452.636 95.4703 452.556 95.727 452.427 95.9607C452.298 96.1944 452.124 96.4012 451.914 96.5674Z",
    fill: "#9C44C0"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlertStatus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert_status.e3a94ef0533888bd806e54b4267f6653.svg";